module.exports = __webpack_public_path__ + "static/media/cooperative-partnerB.81e3d940.png";